import React from 'react';
import JumboContainer from './common/JumboContainer';
import { faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { Card } from 'react-bootstrap';

import '../styles/Team.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { TEAM_MEMBER_1_DESCRIPTION, TEAM_MEMBER_1_NAME, TEAM_MEMBER_1_ROLE, 
  TEAM_MEMBER_2_NAME, TEAM_MEMBER_2_ROLE, TEAM_MEMBER_2_DESCRIPTION, 
  TEAM_MEMBER_3_NAME, TEAM_MEMBER_3_ROLE, TEAM_MEMBER_3_DESCRIPTION, 
  TEAM_MEMBER_4_NAME, TEAM_MEMBER_4_ROLE, TEAM_MEMBER_4_DESCRIPTION,
  TEAM_MEMBER_5_NAME, TEAM_MEMBER_5_ROLE, TEAM_MEMBER_5_DESCRIPTION,
} from '../data/i18n/team';

import Rajendra from '../assets/images/team/Rajendra.jpeg';
import Chandra from '../assets/images/team/Chandra.jpeg';
import Saksham from '../assets/images/team/Saksham.jpeg';
import Ravi from '../assets/images/team/Ravi.jpeg';
import Laxman from '../assets/images/team/Laxman.jpeg';

const members = [
  {
    name: TEAM_MEMBER_1_NAME,
    role: TEAM_MEMBER_1_ROLE,
    image: Rajendra,
    description: TEAM_MEMBER_1_DESCRIPTION,
    // motivation: "BCD",
    socials: [
      {
        thumbnail: faFacebookF,
        link: 'https://facebook.com/freshokartz',
      },
      {
        thumbnail: faLinkedinIn,
        link: 'https://www.facebook.com/rajendra.lora',
      }
    ]
  },
  {
    name: TEAM_MEMBER_2_NAME,
    role: TEAM_MEMBER_2_ROLE,
    image: Chandra,
    description: TEAM_MEMBER_2_DESCRIPTION,
    // motivation: "BCD",
    socials: [
      {
        thumbnail: faFacebookF,
        link: 'https://www.facebook.com/csohu',
      },
      {
        thumbnail: faLinkedinIn,
        link: 'https://www.linkedin.com/in/chandrakanta-sahu-6795095a/',
      }
    ]
  },
  {
    name: TEAM_MEMBER_3_NAME,
    role: TEAM_MEMBER_3_ROLE,
    image: Laxman,
    description: TEAM_MEMBER_3_DESCRIPTION,
    // motivation: "BCD",
    socials: [
      {
        thumbnail: faFacebookF,
        link: 'https://www.facebook.com/lps94',
      },
      {
        thumbnail: faLinkedinIn,
        link: 'https://www.linkedin.com/in/laxman-sharma-328b2659/',
      }
    ]
  },
  {
    name: TEAM_MEMBER_4_NAME,
    role: TEAM_MEMBER_4_ROLE,
    image: Saksham,
    description: TEAM_MEMBER_4_DESCRIPTION,
    motivation: "BCD",
    socials: [
      {
        thumbnail: faLinkedinIn,
        link: 'https://www.linkedin.com/in/mesakshamsharma/',
      }
    ]
  },

  {
    name: TEAM_MEMBER_5_NAME,
    role: TEAM_MEMBER_5_ROLE,
    image: Ravi,
    description: TEAM_MEMBER_5_DESCRIPTION,
    motivation: "BCD",
    socials: [
      {
        thumbnail: faLinkedinIn,
        link: 'https://www.linkedin.com/in/ravi-dhaka-2a0694146/',
      }
    ]
  }
]



const Team = () => {

  const { t } = useTranslation();

  return (
    <JumboContainer id="team" white title="Our Team">
      <div class="team-list">
        {
          members.map(member => (
            <Card style={{  
                width: '20rem',
                padding: '20px',
                borderWidth: 0,
                margin: '0 auto',
                textAlign: 'center',
              }}>
              <Card.Img class="team-memeber_image" variant="top" src={member.image} />
              <Card.Body>
                <Card.Title class="team-member_name">{t(member.name)}</Card.Title>
                <Card.Text>
                  <p class="team-member_role">{t(member.role)}</p>
                  <p class="team-member_description">{t(member.description)}</p>
                  {/* <p class="team-member_motivation">{member.motivation}</p> */}
                
                  <div class="team-member_social">
                    {
                      member.socials.map(social => (
                        <a class="social-link" rel="noreferrer" target="_blank" href={social.link}>
                        <FontAwesomeIcon icon={social.thumbnail} color="white" size='sm'/>
                    </a>
      
                      ))
                    }
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          ))
        }
      </div>
    </JumboContainer>    
  );
}

export default Team;